export const questionnaires = [
  {
    id: 1,
    number: 1,
    institution: "UFPR",
    year: 2017,
    subject: "Matemática",
    createdAt: "2019-06-25T09:52:47-03:00",
    completedAt: "2019-06-25T10:55:47-03:00",
    correctCount: 32,
    totalCount: 50
  },
  {
    id: 2,
    number: 2,
    institution: "ENEM",
    year: 2016,
    subject: "Biologia",
    createdAt: "2019-05-28T21:51:33-03:00",
    completedAt: "2019-05-28T23:51:33-03:00",
    correctCount: 10,
    totalCount: 14
  },
  {
    id: 3,
    number: 3,
    institution: "Fuvest",
    year: 2014,
    subject: "Lingua portuguesa",
    createdAt: "2019-03-28T17:01:03-03:00",
    completedAt: "2019-03-28T17:32:03-03:00",
    correctCount: 40,
    totalCount: 44
  },
  {
    id: 4,
    number: 4,
    institution: "Unicamp",
    year: 2019,
    subject: "Lingua portuguesa",
    createdAt: "2019-07-16T09:51:00-03:00",
    completedAt: "2019-07-16T11:25:00-03:00",
    correctCount: 63,
    totalCount: 90
  }
];
